// TODO: need to refactor

;(function (win) {

  class PaymentCoupon {
    constructor(couponFieldId) {
      this.couponFieldId = couponFieldId || 'get_coupon';
      this.couponField = $(`#${this.couponFieldId}`);
      this.couponValue = this.couponField.val();
      this.checkCouponCode();

      this.couponField.bind('keypress keyup', $.proxy(function () {
        this.validateCoupon();
      }, this));
      this.couponField.on('keyup', $.proxy(function () {
        this.checkCouponCode();
      }, this));
      this.couponField.on('input', $.proxy(function () {
        this.resetPrice();
      }, this));
      this.couponField.on('input', function () {
        $(this).parent().removeClass('field_with_errors').find('.errorText').remove();
        $(this).removeClass('success_field');
      });
    }

    validateCoupon() {
      this.couponField.val(this.couponField.val().replace(/[^a-zA-Z0-9]/g, ''));
    }

    resetPrice() {
      $('.toggle_percent').each((index, elem) => {
        $(elem).text($(elem).data('price'));
      });
    }

    setDiscountPercent(percent) {
      $('.toggle_percent').each((index, elem) => {
        $(elem).text(($(elem).data('price') - $(elem).data('price') * (percent / 100)).toFixed(2));
      });
    }

    updateCouponValue() {
      this.couponValue = this.couponField.val();
    }

    checkCouponCode() {
      this.updateCouponValue();

      if (this.couponValue === '') return;

      if (this.couponValue === '') {
        this.couponField.removeClass('success_field');
      }

      $.ajax({
        method: 'GET',
        url: location.origin + '/api/coupon/' + this.couponValue + `?locale=${I18n.locale}`,
        dataType: 'json',
        context: this,
        success: function (response) {
          this.couponField.addClass('success_field');

          this.setDiscountPercent(response.percents);
        },
        error: function (response) {
          this.resetPrice();

          let errorText = `<span class="errorText">${response.responseJSON.message}</span>`;
          this.couponField.removeClass('success_field').parent().addClass('field_with_errors').append(errorText);
        }
      });
    }
  }

  win.PaymentCoupon = PaymentCoupon;

}(window))


// WEBPACK FOOTER //
// ./app/webpacker/src/js/payments/coupon.js